import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ_ITEMS } from "../data/faq";
import { HelpCircle } from "lucide-react";

const FAQ = () => {
  return (
    <section id="faq" className="max-w-4xl mx-auto px-4 sm:px-6 py-16">
      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-500/10 border border-blue-500/30 text-blue-300 text-xs mb-4">
          <HelpCircle className="w-4 h-4" />
          <span>الأسئلة الشائعة</span>
        </div>
        <h2 className="text-2xl sm:text-4xl font-bold text-white">
          كل ما تحتاج معرفته
        </h2>
      </div>

      <Accordion type="single" collapsible className="space-y-3">
        {FAQ_ITEMS.map((item, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            className="rounded-2xl bg-white/[0.03] border border-white/10 px-4 sm:px-5 data-[state=open]:border-yellow-500/40 transition-colors"
          >
            <AccordionTrigger className="text-white text-start font-semibold text-base sm:text-lg hover:no-underline py-4">
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-white/70 leading-relaxed pb-4">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};

export default FAQ;
